import { errorAlert } from "../utils/alert";
import { api } from "./api";

export function getRequest(endpoint: string) {

    const hasPagination = /pagination/.test(endpoint);

    const url_endpoint = hasPagination ? endpoint : endpoint+"&pagination=-1"

    return api
        .get(url_endpoint)
        .then((response: any) => response.data)
        .catch((error: any) => {
            errorAlert( error?.response?.data?.error ?? "Falha ao obter dados!" );
        });
}